import { normalizeTradeType } from '../components/bl-invoice-trade-dialog';
import type { InvoiceRow } from '../types';

// Editable until the invoice is formally issued (issued_at set); terminal
// Void/Cancelled rows are locked. Delete shares this gate and additionally
// fails server-side when the row has live payments.
export function isRowEditable(invoice: InvoiceRow): boolean {
  return invoice.issued_at === null && invoice.status !== 'Void' && invoice.status !== 'Cancelled';
}

// A BL-based trade invoice (Provisional / Final Settlement) that has been issued
// (any non-Draft/Void/Cancelled status) can be the predecessor of a new Credit
// or Debit Note. Advances have no BL and notes can't chain off another note, so
// both are excluded — this mirrors the server's adjustable-parent guard, so the
// affordance only shows where a create-next would actually succeed.
export function isRowCreatableFrom(invoice: InvoiceRow): boolean {
  // normalizeTradeType accepts both spellings the API serves for final
  // settlements ('Final Settlement' and 'Final_Settlement') — a plain string
  // comparison would hide the affordance on the enum-key spelling.
  const tradeParent = normalizeTradeType(invoice.invoice_type) !== null;
  return (
    tradeParent &&
    invoice.bl_order_id !== null &&
    invoice.invoice_direction !== null &&
    invoice.currency !== null &&
    invoice.status !== 'Draft' &&
    invoice.status !== 'Void' &&
    invoice.status !== 'Cancelled'
  );
}

// A payable invoice past issuance can still have its number / uploaded document
// corrected (amounts stay locked). Receivable issued rows keep the void +
// adjustment-note path, so they stay on the disabled-Edit tooltip.
export function isRowCorrectable(invoice: InvoiceRow): boolean {
  return (
    invoice.issued_at !== null &&
    invoice.invoice_direction === 'Purchase' &&
    invoice.status !== 'Void' &&
    invoice.status !== 'Cancelled'
  );
}
